"use strict";

exports.__esModule = true;
exports.FilterDeviceListContext = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Provides a list of devices to consumers.
 * @component
 */
var FilterDeviceListContext = exports.FilterDeviceListContext = /*#__PURE__*/_react["default"].createContext({});